export default {
  data() {
    return {
      usuarios: [],
      search: "",
      headers: [
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Teléfono",
          align: "center",
          sortable: true,
          value: "telefono[0].telefono",
        },
        {
          text: "Correo",
          align: "center",
          sortable: true,
          value: "correo[0].correo"
        },

        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      loading: false,
      tiposRegimen: [],
      tab: null,
      temp_table: false,
    }
  },
  async created() {
    console.log("estado_declaracion_completo.created");
    let r1 = await this.getRegimenListado();
    await Promise.all([r1]);
  },
  methods: {

    verSuscripciones(item) {
      console.log('verSuscripciones');
      //   console.log('/estado_declaracion_admin/' + 
      //   (item.id)+'/'+("NIT: "+ item.nit + " Nombre: "+ item.nombre) +
      //  '/' + item.nombre +
      //  '/' + item.cui +
      //  '/' + item.nit +
      //  '/' + item.password_sat);

      if (item.password_sat == "") {
        this.$toast.info("No posee password sat")
      } else {
        let routeData = this.$router.resolve({
          path: '/estado_declaracion_admin/' +
            (item.id) + '/' + ("NIT: " + item.nit + " Nombre: " + item.nombre) +
            '/' + item.nombre +
            '/' + item.cui +
            '/' + item.nit +
            '/' + item.password_sat +
            '/' + item.regimen_id
        });
        window.open(routeData.href, '_blank');
        // this.$router.push("/estado_declaracion_admin/" + btoa(JSON.stringify(item)));
      }
    },

    async getUsuariosRegimen(id) {
      console.log("getUsuariosRegimen:"+id);
      this.temp_table = true;
      this.usuarios = [];
      try {
        this.loading = true;
        let r = await this.$store.state.services.administradorService.getListadoUsariosPorRegimen(id);
        r.data.data.filter((x) => {
          x.nombre =
            (x.primer_nombre === null ? '' : x.primer_nombre) +
            " " +
            (x.segundo_nombre === null ? '' : x.segundo_nombre) +
            " " +
            (x.primer_apellido === null ? '' : x.primer_apellido) +
            " " +
            (x.segundo_apellido === null ? '' : x.segundo_apellido);
        });
        this.usuarios = r.data.data;
        this.loading = false;
        console.log("respuesta de usuarios por regimen", r);
      } catch (error) {
        console.log(error);
      }
    },

    async getRegimenListado() {
      console.log("getRegimenListado");
      try {
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        console.log("tipo regimen", r);
        this.tiposRegimen = r.data.data

      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },
  },
  async mounted() {
    console.log("/estado_declaracion_completo");
  },
}